import { css } from "@emotion/css";
import classNames from "classnames";
import { PropsWithChildren } from "react";

import { DashboardSummaryCard } from "./DashboardSummaryCard";
import { CaseCounts } from "../../types";

interface DashboardSummaryProps extends PropsWithChildren {
  title?: string;
  testID?: string;
  className?: string;
  onDataChange?: (data: {
    caseCounts: CaseCounts | null;
    customerGroupId: string | null;
  }) => void;
}

export function DashboardSummary(props: DashboardSummaryProps) {
  const { children, testID, className, onDataChange } = props;

  return (
    <DashboardSummaryCard
      testID={testID}
      className={classNames(styles.card, className)}
      onDataChange={onDataChange}
    >
      <div className={styles.summaryItemContainer}>{children}</div>
    </DashboardSummaryCard>
  );
}

const styles = {
  card: css({
    paddingTop: "var(--space-4)",
    paddingBottom: "var(--space-4)",
  }),
  summaryItemContainer: css({
    display: "flex",
    justifyContent: "space-evenly",
  }),
};
